<template>
  <div v-click-outside="_close" :class="{ 'phone-input': true, disabled }">
    <span class="tel-code-select" @click="_toggle"> +{{ telCode }} </span>
    <Input ref="phone" v-model="phone" :disabled="disabled" v-bind="$attrs" />
    <div v-if="showSelectBox" class="tel-code-panel">
      <div class="tel-code-input">
        <Input
          ref="search"
          v-model="searchText"
          name="search-country-region"
          type="text"
          :placeholder="$t('login.search-country-placeholder')"
          class="search-input"
          autocomplete="off"
          :form="false"
        />
      </div>
      <ul
        v-if="displayTelCodeList && displayTelCodeList.length"
        class="tel-code-list"
      >
        <li
          v-for="country in displayTelCodeList"
          :key="country.country_code"
          class="cell"
          @click="_select(country)"
        >
          <span class="name">{{ country.country }}</span>
          <span class="code">+{{ country.tel_code }}</span>
        </li>
      </ul>
      <span v-else class="no-data">
        {{ $t('no-data') }}
      </span>
    </div>
  </div>
</template>
<script>
import Icon from 'com/Icon'
import Input from 'com/Input'
import { fetchCustomerAccountField } from 'apis/customer'

function getTelValue(tel, defaultTelCode = '1') {
  if (typeof tel === 'string') {
    return {
      phone: tel,
      telCode: defaultTelCode
    }
  }
  if (typeof tel === 'object') {
    return {
      phone: tel.phone,
      telCode: tel.code
    }
  }
  return {
    phone: '',
    telCode: defaultTelCode
  }
}

export default {
  name: 'PhoneInput',
  components: {
    Icon,
    Input
  },
  props: ['tel', 'disabled'],
  model: {
    prop: 'tel',
    event: 'on-change'
  },
  watch: {
    fullPhone(val) {
      this.$emit('on-change', val)
    },
    tel(val) {
      const tel = getTelValue(val)
      this.phone = tel.phone
      this.telCode = tel.telCode
    }
  },
  data() {
    const tel = getTelValue(this.tel)
    return {
      telCode: tel.telCode,
      phone: tel.phone,
      searchText: '',
      showSelectBox: false,
      countryList: []
    }
  },
  mounted() {
    fetchCustomerAccountField('country_us_group').then(({ data: respData }) => {
      if (respData.is_succ) {
        this.countryList = respData.data || []
      }
    })
  },
  computed: {
    displayTelCodeList() {
      const keyword = (this.searchText || '').toUpperCase()
      const displayList = []
      this.countryList.forEach(group => {
        if (group.letter === keyword) {
          displayList.push(...group.items)
        } else {
          if (!this.searchText) return displayList.push(...group.items)
          const filters = group.items.filter(country => {
            return (
              country.country.toUpperCase().indexOf(keyword) > -1 ||
              String(country.tel_code).indexOf(keyword) > -1
            )
          })
          displayList.push(...filters)
        }
      })
      return displayList
    },
    fullPhone() {
      return {
        code: this.telCode,
        phone: this.phone
      }
    }
  },
  methods: {
    _open() {
      this.showSelectBox = true
      this.searchText = ''
      this.$nextTick(() => {
        this.$refs.search && this.$refs.search.focus()
      })
    },
    _close() {
      if (this.showSelectBox) {
        if (!this.phone) this.$refs.phone.focus()
        this.showSelectBox = false
      }
    },
    _reset() {
      this.phone = ''
      this.telCode = '1'
    },
    _toggle() {
      if (this.disabled) return
      this.showSelectBox ? this._close() : this._open()
    },
    _select(country) {
      this.telCode = country.tel_code
      this._close()
    }
  }
}
</script>
<style lang="less" type="text/less" scoped>
@import '~uikit';
@border-color: #e1e6f0;
.phone-input {
  width: 100%;
  position: relative;
  outline: none;
  &.disabled {
    cursor: initial;
    .tel-code-select {
      cursor: not-allowed;
      color: @light-grey;
      &:after {
        border-top-color: @light-grey;
      }
    }
  }
  /deep/ .tt-input {
    padding-left: 65px;
  }
  .tel-code-select {
    position: absolute;
    width: 54px;
    padding-right: 8px;
    padding-left: 10px;
    line-height: 35px;
    font-weight: bold;
    cursor: pointer;
    z-index: 1;
    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      right: 0;
      top: 15px;
      border-style: solid;
      border-color: @black;
      border-width: 5px 4px 0 4px;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }
  }
  .tel-code-panel {
    position: absolute;
    height: 240px;
    border: 1px solid @border-color;
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 2px;
    left: 0;
    right: 0;
    bottom: -5px;
    transform: translateY(100%);
    z-index: 2;
    box-shadow: @box-shadow-0 fade(#3d464d, 10);
    .tel-code-input {
      padding: 15px 15px 5px;
    }
    .search-input {
      /deep/ .tt-input {
        padding-left: 10px;
      }
    }
    .no-data {
      margin: 0;
      padding: 30px 0;
      color: @grey;
      text-align: center;
    }
    .tel-code-list {
      flex: 1;
      min-height: 0;
      padding: 0 15px;
      margin: 0;
      overflow-y: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .cell {
        margin: 0;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: solid 1px @border-color;
        font-size: 14px;
        cursor: pointer;
      }
      .name {
        color: @grey;
      }
      .code {
        font-weight: bold;
      }
    }
  }
}
</style>
